import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

export default function CreateCampaignModal({ isOpen, toggle, setCreateCampaignModal }) {
  const [formData, setFormData] = useState({
    campaignTitle: "",
    targetAudience: "",
    startDate: "",
    endDate: "",
    description: "",
    image: null,
  });

  const [dragActive, setDragActive] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFormData((prev) => ({ ...prev, image: e.dataTransfer.files[0] }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
    }
  };

  const handleSubmit = () => {
    console.log("Campaign Data:", formData);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" className="create-campaign-modal">
      <ModalHeader toggle={toggle}>Create Campaign</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="campaignTitle">Campaign Title</Label>
                <Input
                  type="text"
                  name="campaignTitle"
                  id="campaignTitle"
                  placeholder="Enter campaign title"
                  value={formData.campaignTitle}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="targetAudience">Target Audience</Label>
                <Input
                  type="select"
                  name="targetAudience"
                  id="targetAudience"
                  value={formData.targetAudience}
                  onChange={handleChange}
                >
                  <option value="">Select target audience</option>
                  <option value="all">All</option>
                  <option value="individual">Individual Customer</option>
                  <option value="corporate">Corporate Customer</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row style={{ marginTop: 15, marginBottom: 15 }}>
            <Col md={6}>
              <FormGroup>
                <Label for="startDate">Offer Start Date</Label>
                <Input
                  type="date"
                  name="startDate"
                  id="startDate"
                  placeholder="Select start date"
                  value={formData.startDate}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="endDate">Offer End Date</Label>
                <Input
                  type="date"
                  name="endDate"
                  id="endDate"
                  placeholder="Select end date"
                  value={formData.endDate}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label for="description">Description</Label>
            <Input
              type="textarea"
              name="description"
              id="description"
              placeholder="Enter description"
              rows="4"
              value={formData.description}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>Upload Image</Label>
            <div
              className={`upload-area ${dragActive ? "drag-active" : ""}`}
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
              onClick={() => document.getElementById("fileInput").click()}
            >
              <input
                type="file"
                id="fileInput"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <div className="upload-content">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <polyline points="21 15 16 10 5 21" />
                </svg>
                <p className="upload-text">
                  {formData.image ? formData.image.name : "Click to upload or Drag and drop Banner Images"}
                </p>
              </div>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          style={{ backgroundColor: "#F6F6F6", color: "#8C8C8C" }}
          onClick={() => {
            setCreateCampaignModal(false);
          }}
        >
          Cancel
        </Button>
        <Button style={{ backgroundColor: "#7261FF" }} onClick={handleSubmit}>
          Publish Campaign
        </Button>
      </ModalFooter>

      <style jsx>{`
        :global(.create-campaign-modal .modal-header) {
          border-bottom: 1px solid #e5e7eb;
          padding: 1.25rem 1.5rem;
        }

        :global(.create-campaign-modal .modal-title) {
          font-size: 1.125rem;
          font-weight: 600;
          color: #000;
        }

        :global(.create-campaign-modal .modal-body) {
          padding: 1.5rem;
        }

        :global(.create-campaign-modal .form-label) {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
        }

        :global(.create-campaign-modal .form-control),
        :global(.create-campaign-modal .form-select) {
          border: 1px solid #d1d5db;
          border-radius: 6px;
          padding: 0.625rem 0.875rem;
          font-size: 0.875rem;
          color: #6b7280;
        }

        :global(.create-campaign-modal .form-control:focus),
        :global(.create-campaign-modal .form-select:focus) {
          border-color: #7c3aed;
          box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
        }

        .upload-area {
          border: 2px dashed #d1d5db;
          border-radius: 8px;
          padding: 3rem 2rem;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;
          background-color: #fafafa;
        }

        .upload-area:hover,
        .upload-area.drag-active {
          border-color: #7261ff;
          background-color: #f5f3ff;
        }

        .upload-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
        }

        .upload-text {
          color: #6b7280;
          font-size: 0.875rem;
          margin: 0;
        }

        .modal-footer {
          justify-content: flex-start;
        }

        :global(.create-campaign-modal .modal-footer) {
          border-top: 1px solid #e5e7eb;
          padding: 1.25rem 1.5rem;
          gap: 0.75rem;
        }

        :global(.create-campaign-modal .btn-secondary) {
          background-color: #fff;
          border: 1px solid #d1d5db;
          color: #374151;
          padding: 0.625rem 1.5rem;
          font-size: 0.875rem;
          font-weight: 500;
        }

        :global(.create-campaign-modal .btn-secondary:hover) {
          background-color: #f9fafb;
        }

        :global(.create-campaign-modal .btn-primary) {
          background-color: #7c3aed;
          border: none;
          color: #fff;
          padding: 0.625rem 1.5rem;
          font-size: 0.875rem;
          font-weight: 500;
        }

        :global(.create-campaign-modal .btn-primary:hover) {
          background-color: #6d28d9;
        }
      `}</style>
    </Modal>
  );
}
